import { PanelTypes } from './types';

export const getPanelProperties = (companyId?: number) => ({
  types: [PanelTypes.SHOW_REQUEST, PanelTypes.SHOW_SUCCESS, PanelTypes.SHOW_FAILURE],
  promise: (client: any) =>
    client.get('/painel.json', {
      params: { companyId },
    }),
});

export const send_feedback = (nota: number, feedback: string) => ({
  types: [
    PanelTypes.SEND_FEEDBACK_REQUEST,
    PanelTypes.SEND_FEEDBACK_SUCCESS,
    PanelTypes.SEND_FEEDBACK_FAILURE,
  ],
  promise: (client: any) => client.post('/send_feedback', { nota, feedback }),
});
